import React, {useState} from "react";
import LazyGroupSticker from "./LazyGroupSticker";
import styles from "./UIGroupSticker.module.scss";
import classNames from "classnames";
import {Button} from "antd";

// import history from "./images/history.png";
// uselayouteffec

const UIGroupSticker = (props: any) => {
  // const mySticker = props.mySticker;
  const [myStickerList, setMyStickerList]: any = useState([]);
  const handleSwichSticker = (transactionId: string) => {
    document.querySelectorAll("div.group_sticker_list").forEach((el) => {
      if (el.id === transactionId) {
        el.classList.remove("group_sticker_list_unactive");
        el.classList.add("group_sticker_list_active");
      } else {
        el.classList.remove("group_sticker_list_active");
        el.classList.add("group_sticker_list_unactive");
      }
    });
  };

  // useEffect(() => {
  //   const handleGetSticker = async (packageId, transactionId) => {
  //     let responseData;
  //     try {
  //       responseData = await apiGetStickers.post({
  //         packageId: packageId,
  //       });
  //       if (
  //         responseData?.status?.toLowerCase() ===
  //         sendStatus.Success.toLowerCase()
  //       ) {
  //         await setMyStickerList((prevState) => [
  //           ...prevState,
  //           {
  //             packageId: packageId,
  //             transactionId: transactionId,
  //             data: responseData.objData,
  //           },
  //         ]);
  //       }
  //     } catch (error) {
  //       console.warn("Error handleGetMySticker : ", error);
  //     }
  //   };
  // }, []);

  return (
    <>
      <div
        className={styles.uiGroupSticker}
        style={
          props.isOpenSticker
            ? { display: "block" }
            : { display: "none" }
        }
      >
        <div
          key="detail_history0"
          id="detail_history0"
          className={classNames(styles.group_sticker_list_active, styles.group_sticker_list)}
        >
          <div
            className={classNames(styles.chat_sticker_list, styles.zardGallery)}
          >
            <div
              id={"_chat_sticker_list_"}
              className={classNames(styles.defaultSticker0, "zard-gallery-container", styles.stickerGallery)}
            >
              {[...Array(15)].map((x, i) => (
                <div key={"defaultSticker_0" + i} className={styles.stickerTile}>
                  <img
                    width="100%"
                    height="100%"
                    id={"defaultSticker_0" + i}
                    src={process.env.PUBLIC_URL+"/images/chat-sticker/" + "sticker-" + i + ".png"}
                    className="zard-gallery-content"
                    onClick={() => {
                      props.hendleSendSticker({
                        type: "default",
                        stickerId: "default",
                        transactionId: "default",
                        packageId: 0,
                        url: i,
                      });
                      props.hendleActiveSticker();
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {myStickerList?.map((item : any) => {
          return (
            <div
              key={"detail_" + item.transactionId}
              id={item.transactionId}
              className={classNames(styles.group_sticker_list, styles.group_sticker_list_unactive)}
            >
              <div
                className={styles.chat_sticker_list}
              >
                <ul
                  id={"_chat_sticker_list_" + item.packageId}
                  className={styles.mdRGT09List}
                >
                  {item?.data?.map((childItem: any) => {
                    return (
                      <li key={childItem._id}>
                        <Button>
                          <LazyGroupSticker
                            type="sticker"
                            handleClick={() => {
                              props.hendleSendSticker({
                                type: childItem.stickerId,
                                stickerId: childItem.stickerId,
                                transactionId: item.transactionId,
                                packageId: item.packageId,
                                url: // urlGetStickerImage +
                                item.transactionId +
                                "/stickerId/" +
                                childItem.stickerId,
                              });
                              props.hendleActiveSticker();
                            }}
                            key={
                              "_chat_sticker_item_" +
                              item.transactionId +
                              "_" +
                              childItem.stickerId
                            }
                            id={item.transactionId + "_" + childItem.stickerId}
                            src={
                              // urlGetStickerImage +
                              item.transactionId +
                              "/stickerId/" +
                              childItem.stickerId
                            }
                          />
                        </Button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        })}
        <div
          className={styles.group_sticker_tab_bottom}
        >
          <div className={styles.sticker_tab}>
            <Button
              type="text"
              onClick={() => {
                handleSwichSticker("detail_history0");
              }}
            >
              <img
                src={process.env.PUBLIC_URL+"/images/chat-sticker/sticker-0.png"}
                alt=""
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "contain",
                  visibility: "visible",
                }}
              />
            </Button>

            {myStickerList?.map((item: any) => {
              return (
                <Button
                  key={"tab_" + item.transactionId}
                  onClick={() => {
                    handleSwichSticker(item.transactionId);
                  }}
                >
                  <img
                    alt="preload"
                    src={
                      // urlGetStickerPackageLogo +
                      item.transactionId +
                      "?logo=thumbnail"
                    }
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "contain",
                      visibility: "visible",
                    }}
                  />
                </Button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(UIGroupSticker);
